<template>
    <validation-observer ref="observer" v-slot="{ invalid }">
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card height="100%">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="show">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ buttonState.title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            v-if="!isAuditorRole"
                            :color="buttonState.color"
                            @click="buttonState.action"
                            class="white--text"
                            :disabled="invalid"
                            dark
                            text
                        >
                            {{ buttonState.name }}
                        </v-btn>
                        <v-btn
                            @click="showPrint"
                            class="white--text"
                            dark
                            text
                            v-if="buttonState.name === 'update'"
                        >
                            Print
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-row class="mt-3">
                        <v-col cols="12" md="6">
                            <v-menu
                                ref="month-menu"
                                v-model="monthMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <validation-provider
                                        v-slot="{ errors }"
                                        name="Month"
                                        rules="required"
                                    >
                                        <v-text-field
                                            v-model="item.month"
                                            label="Month"
                                            prepend-inner-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            :error-messages="errors"
                                        ></v-text-field>
                                    </validation-provider>
                                </template>
                                <v-date-picker
                                    type="month"
                                    v-model="item.openedDate"
                                    :active-picker.sync="monthPicker"
                                    @change="saveMonth"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-menu
                                ref="date-menu"
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <validation-provider
                                        v-slot="{ errors }"
                                        name="Day"
                                        rules="required"
                                    >
                                        <v-text-field
                                            v-model="item.openedDate"
                                            label="Day"
                                            prepend-inner-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            :error-messages="errors"
                                        ></v-text-field>
                                    </validation-provider>
                                </template>
                                <v-date-picker
                                    v-model="item.openedDate"
                                    :active-picker.sync="dayPicker"
                                    :max="maxDate"
                                    :min="minDate"
                                    @change="validateDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-checkbox
                                v-model="isChecked"
                                label="Opened By"
                                hide-details
                                @change="addSignature($event)"
                            ></v-checkbox>

                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Signature"
                            >
                                <v-text-field
                                    v-model="item.signature"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </validation-observer>
</template>

<script>
/*eslint-disable */
import moment from "moment";
import {
    ValidationObserver,
    ValidationProvider,
    setInteractionMode,
} from "vee-validate";
import {url} from "@/client_config/config";
import PrintUtil from "../../../../utils/print-util";

setInteractionMode("eager");

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        isAuditorRole: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            monthMenu: false,
            dateMenu: false,
            dialog: false,
            monthDate: null,
            dayPicker: null,
            monthPicker: null,
            isChecked: null,
            minDate: "",
            maxDate: "",
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            item: {},
            bmId: "",
            token: localStorage.getItem('token')
        };
    },

    computed: {
        buttonState() {
            let state = "";
            if (this.bmId === "") {
                state = {
                    name: "save",
                    action: this.save,
                    color: "#259647",
                    title: "Add Seizure",
                };
            } else {
                state = {
                    name: "update",
                    action: this.update,
                    color: "blue darken-1",
                    title: "Update Seizure",
                };
            }
            return state;
        },
    },

    mounted() {
        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.bmId, this.token, 'Seizure');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.bmId, this.token, 'Seizure');
        });
    },

    methods: {
        addSignature(e) {
            if (!e) return (this.item.signature = "");
            this.item.signature = localStorage.getItem("Name") + " - " + new Date();
            //   this.signature = this.$store.state.Auth.user.name + " - " + new Date();
        },
        saveMonth(date) {
            this.minDate = moment(date).startOf("month").format("YYYY-MM-DD");
            this.maxDate = moment(date).endOf("month").format("YYYY-MM-DD");
            const newDate = moment(date);
            this.item.month = this.monthNames[newDate.month()];
            this.item.openedDate = moment(date).startOf("month").format("YYYY-MM-DD");
        },
        validateDate() {
            console.log("validateDate");
        },

        async save() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            this.$emit("save-item", this.item);
        },

        update() {
            this.$emit("update-item", this.item);
        },

        show() {
            this.dialog = !this.dialog;
            this.clear();
        },

        populateData(data) {
            this.$nextTick(() => {
                this.bmId = data._id;
                this.item.month = data.month;
                this.item.openedDate = data.openedDate;
                this.item.signature = `${data.createdBy}`;
            });
        },

        clear() {
            this.item.month = "";
            this.item.openedDate = "";
            this.item.signature = "";
            this.isChecked = null;
            this.bmId = "";
        },

        async generateDownloadUrl() {
            return `${url}/seizures/print-pdf?id=${this.bmId}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            console.log({downloadUrl});
            PrintUtil.showPrintOption(downloadUrl, this.bmId, this.token, 'Seizure');
        },
    },
};
</script>
